function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXtimesLogoWhite = function SvgXtimesLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 79.375 79.375"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.867 5.321)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48.554,
    cy: 34.366,
    r: 36.37,
    className: "cls-2",
    style: {
      stroke: "#fff",
      strokeWidth: "1.85208px",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.482 48.225-5.056 5.056-13.859-13.859-13.94 13.941-5.057-5.056 13.941-13.94-13.859-13.86 5.056-5.056 13.86 13.86 13.86-13.862 5.057 5.056-13.859 13.859 13.86 13.858Z",
    className: "cls-1",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: ".79375px",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.43 78.34-71.49 71.49 71.49 71.49",
    className: "cls-3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    transform: "matrix(.26458 0 0 .26458 8.867 -5.276)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.482 34.43c0-1.754 1.413-3.215 3.165-3.215 1.751 0 3.12 1.463 3.12 3.215s-1.366 3.167-3.12 3.167a3.16 3.16 0 0 1-3.165-3.167zM23.342 34.43c0-1.754 1.413-3.215 3.164-3.215s3.12 1.463 3.12 3.215-1.365 3.167-3.12 3.167a3.16 3.16 0 0 1-3.164-3.167z",
    className: "cls-1",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: ".79375px",
      strokeMiterlimit: 10
    }
  })));
};
export default SvgXtimesLogoWhite;